import React, { useState, useEffect, useRef } from 'react';
import profile from '../../assets/user-profile.png';
import { axiosPrivate } from '../../api/axios';
import { toast } from 'react-toastify';
// import logo from '../../assets/new-dashboard-img/tblogo.png';
import logo from '../../assets/logo.png';

import bell from '../../assets/new-dashboard-img/bell.svg';
import gmail from '../../assets/new-dashboard-img/gmail.svg';
import profilePik from '../../assets/new-dashboard-img/profilepik.png';
import GoogleTranslate from './GoogleTranslate'
const Header = () => {
  const [userDetails, setUserDetails] = useState<any>({});
  const [disable, setDisable] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef();


  const openSideNav = () => {
    var sideNav: any = document.getElementById('sideNav');
    sideNav.classList.toggle('active');
  };
  const user = JSON.parse(localStorage.getItem('user') as string);

  const getUserDetails = async () => {
    await axiosPrivate
      .get(`/user/${user?.id}`)
      .then((res) => setUserDetails(res.data));
  };

  const handleChangeProfilePicture = async (file: File) => {
    const formData = new FormData();
    formData.append('image', file);
    await axiosPrivate.patch('/user/profile-picture', formData).then(() => {
      toast.success('Profile updated successfully!');
      getUserDetails();
    });
  };
  const path = window.location.pathname;
  const segments = path.split('/'); // ["", "assessments", "result-view"]
  const currentPage = segments[2]; // "result-view"
  useEffect(() => {
    if (currentPage === 'result-view') {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [currentPage]);

  const handleLogout = (() => {
    localStorage.clear();
    (window as Window).location = '/login';
  })
  return (
    <header className="sticky top-0 left-0 w-full h-16 bg-white flex items-center z-[99999] border-b border-gray-100" style={disable ? { pointerEvents: 'none' } : {}}>
      <div className="w-[230px] h-full flex items-center justify-center bg-[#1e2a32] px-4"></div>
      {/* Left Section - Empty for Logo or Sidebar */}
      <div className="flex-1"></div>
      {/* Right Section */}
      <div className="flex flex-row items-center gap-6">
        <GoogleTranslate />
        {/* Notification Bell with Badge */}
        <div className="relative flex flex-row items-center justify-center gap-2 w-[70px] h-12 rounded-full border border-gray-300 cursor-pointer hover:bg-gray-100 transition">
          {/* Bell Icon */}
          <svg
            className="w-5 h-5 text-gray-700"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
          >
            <path d="M15 17h5l-1-5a7 7 0 1 0-14 0l-1 5h5"></path>
            <path d="M12 22a2 2 0 0 0 2-2h-4a2 2 0 0 0 2 2z"></path>
          </svg>

          {/* Notification Badge */}
          {/* <span className="bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full">
            8
          </span> */}
        </div>


        {/* Vertical Divider */}
        <div className="w-[1px] h-6 bg-gray-300"></div>


        <div
          id="userDropdown"
          className="relative"
        >
          <div
            className="flex flex-row items-center gap-3 cursor-pointer hover:bg-gray-100 px-3 py-2 rounded-lg transition mr-2"
            onClick={() => setIsOpen(!isOpen)}
          >
            <div className="w-10 h-10 bg-gray-300 rounded-full">
              <img src={profilePik} alt="user" className="w-10 h-10 rounded-full" />
            </div>
            <div className="flex flex-col">
              <span className="text-sm font-semibold text-gray-900" style={{ fontWeight: '700', fontFamily: '"Inter", sans-serif' }}>User</span>
            </div>
            <svg
              className="w-4 h-4 text-gray-700"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              viewBox="0 0 24 24"
            >
              <path d="M6 9l6 6 6-6"></path>
            </svg>
          </div>

          {isOpen && (
            <div
              className={`absolute right-0 mt-2 w-48 bg-white border rounded-lg shadow-md transition-all duration-200 ease-in-out z-50 ${disable ? "opacity-50 pointer-events-none" : ""}`}
            >
              <button
                onClick={handleLogout}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 focus:outline-none rounded-b-lg"
              >
                Logout
              </button>
            </div>
          )}
        </div>

      </div>
    </header>


  );
};

export default Header;